import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentStateChip',
  props: {
    state: null
  },
  setup(__props: any) {



const getRecordIcon = (state: string) => {
  const map: Record<string, string> = {
    pending: "clock-circle",
    paid: "check-circle",
  }

  return map[state] || "record"
}

return { __sfc: true,getRecordIcon }
}

})